import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-secondary relative overflow-hidden py-8 pr-20 pl-6 sm:py-12 sm:pr-20 sm:pl-8',
    title: 'sm:heading-2xl heading-xl pr-4',
    description: 'heading-m mt-3',
    decoration: 'absolute top-5 -right-20 w-42 sm:w-47',
    decorationImage: 'h-auto w-full object-cover'
  }
});
